import React from 'react';
import '../App.css';
import code from './images/QR-code.png';
import location from './images/map.png';

export default function Contact() {
  return (
    <section id="contact" className="contact-section text-light py-5">
      <div className="container">
        <h1 className="contact-title text-center mb-5">
          Contact For More Details
        </h1>

        <div className="row">
          
          <div className="col-12 col-md-7 mb-4">
            <h5 className="text-warning">Let’s Connect</h5>
            <p className="mb-1">Ready to transform your production process?</p>
            <p className="mb-4">Get in touch with our team — we’re here to guide you through every step.</p>

            <p className="fw-bold mb-1">MDQUALITY Apps & Solutions</p>
            <p className="mb-4">Production Management System (PMS) Division</p>

            <p className="d-flex align-items-start mb-4">
              <img src={location} alt="Location" className="location-icon me-2" />
              <span>No 2B, 4th Cross St, near Bethel Party Hall, Vel Nagar, Velu Nagar, Maduravoyal, Chennai, Tamil Nadu 600095</span>
            </p>

            <p className="mb-2">📞 +91-88389 95745</p>
            <p className="mb-2">📧 <a href="mailto:apps@mdqualityapps.com" className="text-light text-decoration-none">apps@mdqualityapps.com</a></p>
            <a href='https://www.mdqualityapps.com/'  target="_blank"  className="text-light text-decoration-none"><p className="mb-0">🌐 www.mdqualityapps.in</p></a>
          </div>

          {/* QR Code */}
          <div className="col-12 col-md-5 text-center">
            <p className="mb-3 fs-5">Please Scan For Our Products</p>
            <img src={code} alt="QR Code" className="img-fluid qr-code-img" />
          </div>
        </div>
      </div>
    </section>
  );
}
